var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIconGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#D1F178"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1179_12952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6667 38.6667H38.3333C35.5778 38.6667 33.3333 40.9112 33.3333 43.6667V77.0001C33.3333 79.7556 35.5778 82.0001 38.3333 82.0001H81.6667C84.4222 82.0001 86.6667 79.7556 86.6667 77.0001V43.6667C86.6667 40.9112 84.4222 38.6667 81.6667 38.6667ZM38.3333 42.0001H81.6667C82.5889 42.0001 83.3333 42.7445 83.3333 43.6667V46.0667L60 63.8001L36.6667 46.0667V43.6667C36.6667 42.7445 37.4111 42.0001 38.3333 42.0001ZM81.6667 78.6667H38.3333C37.4111 78.6667 36.6667 77.9223 36.6667 77.0001V50.2445L58.9889 67.2112C59.2889 67.4334 59.6444 67.5556 60 67.5556C60.3556 67.5556 60.7111 67.4445 61.0111 67.2112L83.3333 50.2445V77.0001C83.3333 77.9223 82.5889 78.6667 81.6667 78.6667Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1179_12952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.3333,
    height: 43.3333,
    fill: "white",
    transform: "translate(33.3333 38.6667)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconGreen);
export default __webpack_public_path__ + "static/media/mail-icon-green.3fff15bc2bd8d43852d451f48ba48540.svg";
export { ForwardRef as ReactComponent };